"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9660],{

/***/ 88402:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ AddToButton_AddToButton)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/components/AddToButtonBase/AddToButtonBase.tsx
var AddToButtonBase = __webpack_require__(83055);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(13210);
// EXTERNAL MODULE: ./src/modules/queue/index.ts + 7 modules
var queue = __webpack_require__(17438);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/util/useAddClickHandler.ts
var useAddClickHandler = __webpack_require__(30734);
;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/components/AddToQueueButton/AddToQueueButton.tsx







const AddToQueueButton = (props)=>{
    const { className, title, inlineIcon, style, size, width, fullWidth, fullWidthOnMobile, product, metadata, force, position, withNonAuthRedirect, withNotification, withErrorModals, withResubscribeFlow = true, withUpgradeFlow, withCaseUpsellModal = true, isAdded: isAddedFromProps, onClick, "data-testid": dataTestId = "addToQueueButton" } = props;
    const [submit, { isFetching }] = (0,queue/* useQueueAddItems */.Rx)();
    const { isAdded: isAddedAfterClick, handleClick } = (0,useAddClickHandler/* default */.Z)(async ()=>{
        // TODO add event - added on 2021-11-26 by maddoger
        const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
        await submit({
            product,
            force,
            position,
            metadata: {
                page,
                pageType,
                ...metadata
            }
        }, {
            withErrorModals,
            withNonAuthRedirect,
            withNotification,
            withResubscribeFlow,
            withUpgradeFlow,
            withCaseUpsellModal
        });
        if (typeof onClick === "function") {
            onClick();
        }
    });
    /* some products don't have tradingItem when they are out of stock, so we disable the button in this case */ const isOutOfStock = !product.tradingItemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToButtonBase/* default */.Z, {
        className: className,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        title: title || messages/* default */.Z.addToQueue,
        inlineIcon: inlineIcon,
        isAdded: isAddedFromProps ?? isAddedAfterClick,
        loading: isFetching,
        isOutOfStock: isOutOfStock,
        disabled: isOutOfStock,
        onClick: handleClick,
        "data-testid": dataTestId,
        "data-cnstrc-btn": "add_to_queue"
    });
};
/* harmony default export */ const AddToQueueButton_AddToQueueButton = (AddToQueueButton);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(30468);
;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/components/AddToQueueTryItOldViewButton/messages.ts
/* harmony default export */ const AddToQueueTryItOldViewButton_messages = ({
    tryFragrance: {
        en: "Try this fragrance"
    }
});

;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/components/AddToQueueTryItOldViewButton/AddToQueueTryItOldViewButton.tsx








const AddToQueueTryItOldViewButton = (props)=>{
    const { className, "data-testid": dataTestId = "addToQueueButton", product, metadata, force, position, withNonAuthRedirect, withNotification, withErrorModals, withResubscribeFlow = true, onClick } = props;
    const [submit, { isFetching }] = (0,queue/* useQueueAddItems */.Rx)();
    const { isAdded, handleClick } = (0,useAddClickHandler/* default */.Z)(async ()=>{
        const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
        await submit({
            product,
            force,
            position,
            metadata: {
                page,
                pageType,
                ...metadata
            }
        }, {
            withErrorModals,
            withNonAuthRedirect,
            withNotification,
            withResubscribeFlow
        });
        if (typeof onClick === "function") {
            onClick();
        }
    });
    /* some products don't have tradingItem when they are out of stock, so we disable the button in this case */ const isOutOfStock = !product.tradingItemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "mb-24 bg-gold-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (0,clsx/* default */.Z)("h-s24 text-t4", isAdded ? "text-gold-70" : "hover:text-gold-30"),
                title: isAdded ? messages/* default */.Z.added : AddToQueueTryItOldViewButton_messages.tryFragrance,
                leftIcon: isAdded ? "24/checkmark-in-circle" : isFetching ? "20/loader" : "24/plus-in-circle",
                size: null,
                style: null,
                loading: isFetching,
                disabled: isOutOfStock,
                onClick: handleClick,
                fullWidth: true,
                "data-testid": dataTestId
            })
        ]
    });
};
/* harmony default export */ const AddToQueueTryItOldViewButton_AddToQueueTryItOldViewButton = (AddToQueueTryItOldViewButton);

// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/components/AddToCartButton/AddToCartButton.tsx
var AddToCartButton = __webpack_require__(55805);
;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/AddToButton.tsx






// this button isn't very optimal from re-rendering standpoint, but it usually sits in React.memo(ProductCard)
const AddToButton = (props)=>{
    const { type, ...rest } = props;
    const { className, "data-testid": dataTestId } = rest;
    if (type === "cart") {
        const { product, size, style, width, fullWidth, fullWidthOnMobile, metadata, title, withNotification, withErrorModals, withRedirectToCheckout, onClick } = props;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* default */.Z, {
            className: className,
            style: style,
            size: size,
            width: width,
            fullWidth: fullWidth,
            fullWidthOnMobile: fullWidthOnMobile,
            product: product,
            metadata: metadata,
            title: title,
            withErrorModals: withErrorModals,
            withNotification: withNotification,
            withRedirectToCheckout: withRedirectToCheckout,
            onClick: onClick,
            "data-testid": dataTestId
        });
    }
    if (type === "custom") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToButtonBase/* default */.Z, {
            ...rest
        });
    }
    // queue
    const { product, metadata, force, position, withErrorModals, withNotification, withNonAuthRedirect, withCaseUpsellModal, withUpgradeFlow, onClick } = props;
    if (type === "queueTryItOldView") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToQueueTryItOldViewButton_AddToQueueTryItOldViewButton, {
            className: className,
            product: product,
            metadata: metadata,
            force: force,
            position: position,
            withErrorModals: withErrorModals,
            withNotification: withNotification,
            withNonAuthRedirect: withNonAuthRedirect,
            onClick: onClick,
            "data-testid": dataTestId
        });
    }
    const { title, inlineIcon, size, style, width, fullWidth, fullWidthOnMobile, isAdded } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToQueueButton_AddToQueueButton, {
        className: className,
        title: title,
        inlineIcon: inlineIcon,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        product: product,
        metadata: metadata,
        force: force,
        position: position,
        withErrorModals: withErrorModals,
        withNotification: withNotification,
        withNonAuthRedirect: withNonAuthRedirect,
        withCaseUpsellModal: withCaseUpsellModal,
        withUpgradeFlow: withUpgradeFlow,
        isAdded: isAdded,
        onClick: onClick,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const AddToButton_AddToButton = (AddToButton);


/***/ }),

/***/ 83055:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(927);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34212);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30468);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90234);





const AddToButtonBase = (props)=>{
    const { children, className, to, style = "primary", size = 48, width, fullWidth, fullWidthOnMobile, title, inlineIcon, addedMessage, isAdded, isOutOfStock, disabled, loading, onClick, "data-testid": dataTestId, "data-cnstrc-btn": dataCnstrcBtn } = props;
    let content;
    if (children) {
        content = children;
    } else if (isOutOfStock) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            value: components_inputs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.outOfStock
        });
    } else if (isAdded) {
        const addedColor = style === "primary" ? "text-gold-30" : "text-gold-70";
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `flex items-center justify-center ${addedColor}`,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    value: addedMessage || components_inputs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.added
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "ml-4",
                    name: "24/checkmark"
                })
            ]
        });
    } else {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    value: title
                }),
                Boolean(inlineIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "ml-4",
                    name: inlineIcon
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: className,
        to: to,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        disabled: disabled,
        loading: loading,
        "data-testid": dataTestId,
        "data-cnstrc-btn": dataCnstrcBtn,
        onClick: onClick,
        children: content
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AddToButtonBase);


/***/ }),

/***/ 55805:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13210);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39977);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63687);
/* harmony import */ var helpers_getters__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(811);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64667);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59247);
/* harmony import */ var modules_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13909);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34212);
/* harmony import */ var _util_useAddClickHandler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30734);
/* harmony import */ var _AddToButtonBase_AddToButtonBase__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83055);












const AddToCartButton = (props)=>{
    const { children, className, style, size, width, fullWidth, fullWidthOnMobile, product, metadata, title = components_inputs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.addToCart, withErrorModals = true, withNotification = true, withRedirectToCheckout = false, onClick, "data-testid": dataTestId = "addToCartButton" } = props;
    const { shownPopups } = (0,modules_user__WEBPACK_IMPORTED_MODULE_3__/* .useShownPopups */ .BP)();
    const [submit, { isFetching }] = (0,modules_cart__WEBPACK_IMPORTED_MODULE_4__/* .useCartAddProduct */ .H3)();
    const isCaseUpsellModalEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.features.caseUpsellAddToCart);
    const isHereticCaseUpsellModalEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.features.caseUpsellHeretic);
    const { isAdded, handleClick } = (0,_util_useAddClickHandler__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(async ()=>{
        var _shownPopups_driftRefillClipDisclaimerModal;
        let openCaseUpsellModal;
        let openDriftRefillClipDisclaimerModal;
        const { page, pageType } = (0,analytics__WEBPACK_IMPORTED_MODULE_8__/* .getAnalyticsContext */ .cV)();
        const processSubmit = async ()=>{
            const withCaseUpsellModal = Boolean(openCaseUpsellModal);
            const withCartOpen = props.withCartOpen !== undefined ? props.withCartOpen : !withRedirectToCheckout && !withCaseUpsellModal;
            await submit({
                product,
                metadata: {
                    page,
                    pageType,
                    ...metadata
                }
            }, {
                withErrorModals,
                withNotification: !withCaseUpsellModal && !withCartOpen && withNotification,
                withRedirectToCheckout,
                withCartOpen
            });
            if (typeof onClick === "function") {
                onClick();
            }
        };
        if (product.isRefill && !((_shownPopups_driftRefillClipDisclaimerModal = shownPopups["driftRefillClipDisclaimerModal"]) === null || _shownPopups_driftRefillClipDisclaimerModal === void 0 ? void 0 : _shownPopups_driftRefillClipDisclaimerModal.lastUpdated)) {
            void (0,modals__WEBPACK_IMPORTED_MODULE_9__/* .preloadModal */ .My)("driftRefillClipDisclaimerModal");
            openDriftRefillClipDisclaimerModal = ()=>{
                (0,modals__WEBPACK_IMPORTED_MODULE_9__/* .openModal */ .h7)("driftRefillClipDisclaimerModal", {
                    productId: product.productId,
                    tradingItemId: product.tradingItemId,
                    onClose: processSubmit
                });
            };
        } else if (product.isVial && !product.is1_5mlVial && !product.isLimitedDrop) {
            if (isHereticCaseUpsellModalEnabled && product.brand.toUpperCase().startsWith("HERETIC")) {
                const cookieCondition = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    cookieName: helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.cookieNames.isHereticCaseUpsellModalShown,
                    countPerDay: 5
                });
                if (cookieCondition.isVisible) {
                    void (0,modals__WEBPACK_IMPORTED_MODULE_9__/* .preloadModal */ .My)("hereticCaseUpsellModal");
                    openCaseUpsellModal = ()=>{
                        (0,modals__WEBPACK_IMPORTED_MODULE_9__/* .openModal */ .h7)("hereticCaseUpsellModal", {
                            product,
                            addTo: "cart",
                            onClose: cookieCondition.onClose
                        });
                    };
                }
            } else if (isCaseUpsellModalEnabled) {
                const cookieCondition = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    cookieName: helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.cookieNames.isAddToCartCaseUpsellModalShown,
                    countPerDay: 3
                });
                if (cookieCondition.isVisible) {
                    void (0,modals__WEBPACK_IMPORTED_MODULE_9__/* .preloadModal */ .My)("caseUpsellModal");
                    openCaseUpsellModal = ()=>{
                        (0,modals__WEBPACK_IMPORTED_MODULE_9__/* .openModal */ .h7)("caseUpsellModal", {
                            product,
                            addTo: "cart",
                            onClose: cookieCondition.onClose
                        });
                    };
                }
            }
        }
        if (openDriftRefillClipDisclaimerModal) {
            openDriftRefillClipDisclaimerModal();
        } else {
            await processSubmit();
        }
        if (openCaseUpsellModal) {
            openCaseUpsellModal();
        }
    });
    /* some products don't have tradingItem when they are out of stock, so we disable the button in this case */ const isOutOfStock = !product.tradingItemId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddToButtonBase_AddToButtonBase__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        className: className,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        title: title,
        isAdded: isAdded,
        loading: isFetching,
        disabled: isOutOfStock,
        isOutOfStock: isOutOfStock,
        onClick: handleClick,
        "data-testid": dataTestId,
        "data-cnstrc-btn": "add_to_cart",
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AddToCartButton);


/***/ }),

/***/ 30734:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83305);


const useAddClickHandler = (onClick)=>{
    const [isAdded, setAddedState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const onClickRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onClick);
    onClickRef.current = onClick;
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async ()=>{
        try {
            if (typeof onClickRef.current === "function") {
                await onClickRef.current();
            }
            setAddedState(true);
            timeoutRef.current = setTimeout(()=>{
                setAddedState(false);
            }, 3000);
        } catch (error) {
            return (0,helpers__WEBPACK_IMPORTED_MODULE_1__/* .processError */ .wY)(error);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        isAdded,
        handleClick
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useAddClickHandler);


/***/ })

}]);